export enum CustomFieldResourceType {
  CONTROL = 'CONTROL',
  REQUIREMENT = 'REQUIREMENT',
  RISK = 'RISK',
}

export enum CustomFieldType {
  FREE_TEXT = 'FreeText',
  DROPDOWN = 'DropDown',
  TAGS = 'MultiSelect'
}

export enum EditCustomFieldPermission {
  ALL = 'all',
  ADMINS = 'admins',
}

export interface CustomFieldMetadataItem {
  /**
   * The property represents frameworks where this custom field is linked.
   * null means this custom field is linked to all applicable frameworks
   */
  framework_ids?: string[] | null;
}

export type CustomFieldMetadata = {
  [key in CustomFieldResourceType]?: CustomFieldMetadataItem;
};

export interface CustomDropdownFieldValue {
  id: string;
  value: string;
}

export interface FieldMetadata {
  values?: Record<string, string>;
  who_can_edit?: EditCustomFieldPermission;
  allow_auditors_to_view?: boolean;
}

export interface CustomField {
  id?: string;
  name?: string;
  type?: CustomFieldType;
  description?: string;
  resource_types?: CustomFieldResourceType[];
  metadata?: CustomFieldMetadata;
  is_new?: boolean;
  field_metadata?: FieldMetadata;
}
